import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Theme toggle
const STORAGE_KEY = "theme"

function getPreferredTheme() {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === "light" || stored === "dark") return stored
  return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark"
}

function setTheme(theme) {
  document.documentElement.setAttribute("data-theme", theme)
  localStorage.setItem(STORAGE_KEY, theme)

  const darkIcon = document.querySelector(".theme-icon-dark")
  const lightIcon = document.querySelector(".theme-icon-light")
  if (darkIcon && lightIcon) {
    darkIcon.style.display = theme === "dark" ? "inline" : "none"
    lightIcon.style.display = theme === "light" ? "inline" : "none"
  }

  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) {
    meta.setAttribute("content", theme === "dark" ? "#0d1117" : "#fafafa")
  }
}

const toggle = document.getElementById("theme-toggle")
if (toggle) {
  // Apply saved or preferred theme on load
  setTheme(getPreferredTheme())

  toggle.addEventListener("click", () => {
    const current = document.documentElement.getAttribute("data-theme")
    setTheme(current === "dark" ? "light" : "dark")
  })
}

// Listen for system theme changes
window.matchMedia("(prefers-color-scheme: light)").addEventListener("change", (e) => {
  if (!localStorage.getItem(STORAGE_KEY)) {
    setTheme(e.matches ? "light" : "dark")
  }
})
